<template>
  <v-container>
    <div class="row">
      <div class="col-md-10 col-sm-12 col-xs-12">
        <v-card class="top">
          <v-layout row>
            <v-flex md9 sm9 xs9>
              <v-text-field
                label="Ideas de Fuerzas"
                @click="pickFile('0')"
                v-model="FileName[0]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][0]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file0"
                ref="myFiles0"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('0')"
                multiple
              />
            </v-flex>

            <v-flex md2 sm1 xs1>
              <v-btn
                v-if="this.filesDge['dge'][0]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('0')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][0]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('0')"
                :disabled="disabled[0]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

                 <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="PEI 2018-2020"
                @click="pickFile('6')"
                v-model="FileName[6]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][6]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file6"
                ref="myFiles6"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('6')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][6]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('6')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][6]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('6')"
                :disabled="disabled[6]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

                  <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Resultado encuesta"
                @click="pickFile('9')"
                v-model="FileName[9]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][9]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file9"
                ref="myFiles9"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('9')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][9]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('9')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][9]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('9')"
                :disabled="disabled[9]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

      

          <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Metodología PEI"
                @click="pickFile('8')"
                v-model="FileName[8]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][8]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file8"
                ref="myFiles8"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('8')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][8]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('8')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][8]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('8')"
                :disabled="disabled[8]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

       


        <v-card>
          <v-layout row>
            <v-flex md9 sm9 xs9>
              <v-text-field
                label="Resumen de diagnostico"
                @click="pickFile('1')"
                v-model="FileName[1]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][1]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file1"
                ref="myFiles1"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('1')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][1]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('1')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][1]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('1')"
                :disabled="disabled[1]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Entrevista de Autoridades"
                @click="pickFile('2')"
                v-model="FileName[2]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][2]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file2"
                ref="myFiles2"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('2')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][2]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('2')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][2]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('2')"
                :disabled="disabled[2]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Entrevistas grupales"
                @click="pickFile('3')"
                v-model="FileName[3]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][3]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file3"
                ref="myFiles3"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('3')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][3]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('3')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][3]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('3')"
                :disabled="disabled[3]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Informe PESTEL"
                @click="pickFile('4')"
                v-model="FileName[4]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][4]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file4"
                ref="myFiles4"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('4')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][4]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('4')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][4]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('4')"
                :disabled="disabled[4]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

                <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Entrevista academico"
                @click="pickFile('7')"
                v-model="FileName[7]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][7]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file7"
                ref="myFiles7"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('7')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][7]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('7')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][7]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('7')"
                :disabled="disabled[7]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

      
        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Informe de Tendencias"
                @click="pickFile('5')"
                v-model="FileName[5]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][5]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file5"
                ref="myFiles5"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('5')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][5]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('5')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][5]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('5')"
                :disabled="disabled[5]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

      </div>
    </div>
  </v-container>
</template>


<script>
export default {
  /*
      Defines the data used by the component
    */
  data() {
    return {
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      path: "",
      disabled: [true, true, true, true, true, true, true, true, true, true],
      file: "",
      filesDge: "",
      filess: {
        0: "",
        1: "",
        2: "",
        3: "",
        4: "",
        5: "",
        6: "",
        7: "",
        8: "",
        9: ""
      },
      FileName: {
        0: "",
        1: "",
        2: "",
        3: "",
        4: "",
        5: "",
        6: "",
        7: "",
        8: "",
        9: ""
      }
    };
  },

  created() {
    //console.log(this.auth);

    axios
      .get(
        process.env.ROOT_API + "/encuesta/getById?id=5cb79a55bb25e512e33b3ff1",
        this.auth
      )
      .then(response => {
        //console.log("VAMOS A VER EL ERRORR --------------------------------------------");
        //console.log(response.data);
      })
      .catch(error => {
        console.error(error);
      });

    axios
      .get(
        process.env.ROOT_API + "/uploadFileDcaEtc/getByCcValor?ccValor=0",
        this.auth
      )
      .then(response => {
        this.filesDge = response.data;
        //console.log(this.filesDge);
      })
      .catch(error => {
        console.error(error);
      });
  },

  methods: {
    /*
        Submits the file to the server
      */
    submitFile(index) {
      /*
                Initialize the form data
            */

      let formData = new FormData();
      var name = this.filess[index].name;
      //console.log("indice: " + index);
      /*
                Add the form data we need to submit
            */
      formData.append("file", this.filess[index]);
      //console.log(formData);

      /*
          Make the request to the POST /single-file URL
        */

      axios
        .post(
          process.env.ROOT_API + "/uploadFileDcaEtc/createFile?cc=0",
          formData,
          this.auth
        )
        .then(response => {
          //console.log("SUCCESS!!");
          //console.log(response.data);
          this.path = response.data;
          this.filesDge.dge[index]["saved"] = "si";
          this.filesDge.dge[index]["path"] = response.data[0];
          this.filesDge.dge[index]["name"] = response.data[1];
          alert("Archivo: " + name + " fue cargado exitosamente.");
        })
        .catch(error => {
          //console.log("FAILURE!!");
          alert("Error al cargar el archivo" + name + " ," + error);
        })
        .then(response => {
          axios
            .post(
              process.env.ROOT_API +
                "/uploadFileDcaEtc/updateFileValue?ccValor=0&tipoData=dge",
              this.filesDge.dge,
              this.auth
            )
            .then(response => {
              //console.log(response.data);
              //console.log("funcionando");
            })
            .catch(error => {
              console.error(error);
            });
        });
    },

    /*
        Handles a change on the file upload
      */
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      //console.log(this.file);
    },

    previewFiles(index) {
      //console.log(index);
      this.filess[index] = this.$refs["myFiles" + index].files[0];
      //console.log(this.filess);
      this.FileName[index] = this.$refs["myFiles" + index].files[0].name;
    },
    pickFile(index) {
      //console.log("entrando a pick file");
      this.$refs["myFiles" + index].click();
      this.disabled[index] = false;
    },

    // TODO
    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },

    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>


<style scoped>
.v-card {
  margin-bottom: 1%;
  padding-right: 3%;
  padding-left: 3%;
  padding-top: 0.5%;
}

.top {
  margin-top: 50px;
}

.bot {
  margin-bottom: 50px;
}

.primary--text {
  color: #ec6a12 !important;
  caret-color: #ec6a12 !important;
}

.v-text-field .v-label--active {
  color: #ec6a12 !important;
}

.v-btn--floating.v-btn--small {
  height: 35px !important;
  width: 35px !important;
  margin-top: 15px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/primeraEtapa/Dge.vue